import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_2pgyi0ok2w: FaireBrandEntity = {
  token: "b_2pgyi0ok2w",
  type: "brand",
  name: "National Bobblehead Hall of Fame and Museum",
  avatarUrl:
    "https://cdn.faire.com/fastly/ff54d8aac8adc0fee6152c5d584444046e60aa11dcaa6cceb1dcd9c5249fb1f4.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/b92fcf304e57b1febf6d5188d26b53eddd1a0af8aae67e5b73d3c350f54bb0e9.png",
  logoUrl:
    "https://cdn.faire.com/fastly/ff54d8aac8adc0fee6152c5d584444046e60aa11dcaa6cceb1dcd9c5249fb1f4.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/b92fcf304e57b1febf6d5188d26b53eddd1a0af8aae67e5b73d3c350f54bb0e9.png",
  location: "Milwaukee, WI, USA",
  minimumOrderDollars: 138,
  rating: 4.2,
  reviewCount: 11,
  isInsider: true,
  description:
    "The National Bobblehead Hall of Fame and Museum has the widest selection of bobbleheads in the world! The idea for the museum started with two friends' passion for \ncollecting bobbleheads. When they produced and marketed bobbleheads to honor their friend and Special Olympian, they realized there were a lot of people and characters who never had bobbleheads. They developed a one-of-a-kind Museum dedicated to bobbleheads that also produces and markets high quality bobbleheads.",
  meta: {
    source: "api",
    importedAt: "2026-05-21T20:35:48.341Z",
    importedBy: "entity-db-cli",
  },
};
